import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import {
  BackgroundImage,
  Row, Button,
} from './Styles';
import Header from '../../../../../Common/Header';
import { checkGreen } from '../../../../../../../assets/Base64Image';
import { Box, Driver, Order } from '../../../../../../../lib/types';
import { getFoodifoxData, updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import ProblemReportModal from '../../../../../Common/ProblemReportModal';
import NoFreeBoxModal from '../../../../../Common/NoFreeBoxModal';
import ReopenButton from '../../../../../Common/ReopenButton';
import OpenedBox from '../../../../../Common/OpenedBox/Driver';
import { getCabId32Str } from '../../../../../../../lib/utils/utils';
import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';
import DividerLine from '../../../../../../../components/DividerLine';
import PhoneNumberText from '../../../../../../../components/PhoneNumberText';
import RowBetween from '../../../../../../../components/Layout/RowBetween';

const OpenBoxSuccess: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  driverId,
  pickupCode,
  orderId,
  platform,
  onClose,
  openedBoxes,
  parcelPhoneNumber,
}) => {
  const [reopenBoxLazy, { loading: reopenLoading }] = updateFoodifoxData('/foxH5Driver/reopenOrderBoxByCode');
  const [saveReasonLazy, { loading: saveReasonLoading }] = updateFoodifoxData<{ cabSizeType: string; openBoxes: Box[] }>('/foxH5RentLog/saveCannotUseCabReason');
  const { data: orderData, loading: getOrderDataLoading, refetch: refetchOrder } = getFoodifoxData<Order>('/foxWebH5Order/getById?orderId=' + orderId);
  const { data: orderDateData, loading: checkSaveTimeLoading } = getFoodifoxData<{ saveCabDate: string }>('/foxH5Check/getOrderSaveCabDate', { orderId });

  const timeWaitRef = useRef<number>();

  const [curOpenedBoxes, setCurOpenedBoxes] = useState<Box[]>(openedBoxes);
  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [timeWait, setTimeWait] = useState<string>();
  const [showProblemModal, setShowProblemModal] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(reopenLoading || checkSaveTimeLoading || saveReasonLoading || getOrderDataLoading);

    return () => {
      setShowLoading(false);
    };
  }, [reopenLoading, checkSaveTimeLoading, saveReasonLoading, getOrderDataLoading]);

  useEffect(() => {
    if (orderDateData && orderDateData.saveCabDate) {
      const time = 60 - (new Date().getTime() - new Date(orderDateData.saveCabDate.replace(/-/g, '/')).getTime()) / 1000;
      timeWaitRef.current = time < 0 ? 0 : time;
      setTimeWait(timeWaitRef.current.toFixed(0));
    }
  }, [orderDateData]);

  useEffect(() => {
    setInterval(() => {
      if (timeWaitRef.current != null && timeWaitRef.current <= 1) {
        timeWaitRef.current = 0;
        setTimeWait('0');
        return;
      }
      if (timeWaitRef.current != null && timeWaitRef.current > 1) {
        timeWaitRef.current -= 1;
        setTimeWait(timeWaitRef.current.toFixed(0));
      }
    }, 1000);
  }, []);

  /**
   * 重新开柜门
   */
  const reopenBox = () => {
    // 超过1分钟后，需要去到重新开门页面
    if (timeWaitRef.current == null || timeWaitRef.current <= 0) {
      // 清理之前选择的平台信息
      onClose();
      return;
    }

    if (orderData) {
      reopenBoxLazy({
        param: {
          cabId: getCabId32Str(orderData.useCabId),
          openCode: pickupCode,
          platform,
        },
      });
    }
  };

  return (
    <BackgroundImage>
      {
        showProblemModal && (
          <ProblemReportModal
            onClose={() => setShowProblemModal(false)}
            onConfirm={(reason) => {
              if (orderData) {
                setShowProblemModal(false);
                saveReasonLazy({
                  param: {
                    cabId: getCabId32Str(orderData.useCabId),
                    boxNumbers: JSON.stringify(curOpenedBoxes.map((box) => box.boxNumber)),
                    reportUser: 'Driver',
                    driverId,
                    reason,
                  },
                  onError() {
                    setShowNoFreeBoxModal(true);
                  },
                  onCompleted({ openBoxes }) {
                    refetchOrder();
                    setCurOpenedBoxes(openBoxes);
                  },
                });
              }
            }}
            isEnglish={isEnglish}
            optionKeys={['Dirty', 'Door is not working', 'Other']}
          />
        )
      }
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal onClose={() => setShowNoFreeBoxModal(false)} isEnglish={isEnglish} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={() => onClose()}
        showSupport={false}
        showHome={true}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      {
        isEnglish ? (
          <SquadSemiBoldText fontSize={22} textAlign={'center'} marginTop={35}>
            Rental Success!
          </SquadSemiBoldText>
        ) : (
          <PingFangMediumText fontSize={22} textAlign={'center'} marginTop={35}>
            租用成功
          </PingFangMediumText>
        )
      }

      {
        isEnglish ? (
          <SquadRegularText fontSize={16} lineHeight={24} textAlign={'center'} marginTop={15}>
            A cubicle has opened. Please put the food
            <br />
            order inside and close the door.
          </SquadRegularText>
        ) : (
          <PingFangRegularText fontSize={16} lineHeight={24} textAlign={'center'} marginTop={15}>
            一个柜门已打开。请将食品订单
            <br />
            放入其中并关上柜门。
          </PingFangRegularText>
        )
      }

      {/* 柜子打开的柜门 */}
      {
        curOpenedBoxes.map((box) => (
          <OpenedBox
            key={box.boxNumber}
            width={335}
            boxNumber={box.boxNumber}
            isEnglish={isEnglish}
            cabSizeType={box.cabSizeType}
            lockAddress={box.lockNumber}
            lockPort={box.lockPort}
          />
        ))
      }

      {/* 分隔线 */}
      <DividerLine backgroundColor={'#11202B'} opacity={0.1} marginTop={25} marginBottom={25} width={311} marginLeft={'auto'} marginRight={'auto'} />
      <div style={{ textAlign: 'center' }}>
        {
          isEnglish ? (
            <>
              <SquadSemiBoldText fontSize={16} color={'#00B595'} isSpan={true} lineHeight={24}>
                <PhoneNumberText phoneNumber={parcelPhoneNumber} />
              </SquadSemiBoldText>
              <SquadRegularText fontSize={16} color={'#989898'} lineHeight={24} isSpan={true} marginLeft={5}>
                will receive SMS with the QR
              </SquadRegularText>
              <SquadRegularText fontSize={16} color={'#989898'} lineHeight={24}>
                code to open to locker and pickup the item.
              </SquadRegularText>
            </>
          ) : (
            <>
              <PingFangRegularText fontSize={16} textAlign={'center'} color={'#989898'} lineHeight={24} isSpan={true}>
                收件人将收到带有二维码的短信，
                <br />
                以打开储物柜并提取订单。
              </PingFangRegularText>
            </>
          )
        }
      </div>

      <RowBetween style={{ width: 335, marginLeft: 'auto', marginRight: 'auto', marginTop: 36 }}>
        {/* 重新打开柜门 */}
        <ReopenButton
          onClick={() => reopenBox()}
          isEnglish={isEnglish}
          timeWait={timeWait}
          style={{ width: 162, height: 54, borderRadius: 60, backgroundColor: '#00B595' }}
        />

        {/* 不能使用柜门，弹出反馈窗口，然后重新打开新柜门 */}
        <Button
          onClick={() => setShowProblemModal(true)}
          style={{ width: 169, height: 54, background: '#11202B', borderRadius: 60 }}>
          {
            isEnglish ? (
              <SquadSemiBoldText fontSize={16} color={'#FFFFFF'}>
                Report problems
              </SquadSemiBoldText>
            ) : (
              <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '20px' }}>
                反馈柜子问题
              </div>
            )
          }
        </Button>
      </RowBetween>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  pickupCode: string;
  orderId: number;
  platform: number;
  onClose: () => void;
  openedBoxes: Box[];
  parcelPhoneNumber: string;
}

export default OpenBoxSuccess;
